// @flow

export default class PaymentMethod {
  fee: number;
  fee_type: string;
  payment_method: string;
  subtype: string;
  name: String;

  constructor(data: any = {}) {
    this.fee = data.fee;
    this.fee_type = data.fee_type;
    this.payment_method = data.payment_method;
    this.subtype = data.subtype;
    this.name = data.name;
  }
}
